import { render, staticRenderFns } from "./envelope-recipients.vue?vue&type=template&id=59a552b5&scoped=true"
import script from "./envelope-recipients.vue?vue&type=script&lang=js"
export * from "./envelope-recipients.vue?vue&type=script&lang=js"
import style0 from "./envelope-recipients.vue?vue&type=style&index=0&id=59a552b5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59a552b5",
  null
  
)

export default component.exports